import { apiClient } from "./client";

export const fetchKbFolders = async () => (await apiClient("GET", "/knowledge-base/folders")).data;

export async function fetchKbDocuments({ folderId, q } = {}) {
  const params = new URLSearchParams();
  if (folderId) params.set("folder_id", folderId);
  if (q) params.set("q", q);
  return (await apiClient("GET", `/knowledge-base/documents?${params}`)).data;
}

export const createKbFolder = async (name, parentId = null) => (await apiClient("POST", "/knowledge-base/folders", { name, parent_id: parentId })).data;
export const renameKbFolder = async (id, name) => (await apiClient("PATCH", `/knowledge-base/folders/${id}`, { name })).data;
export const setKbFolderHiddenRoles = async (id, hiddenFromRoles) => (await apiClient("PATCH", `/knowledge-base/folders/${id}`, { hidden_from_roles: hiddenFromRoles })).data;
export const deleteKbFolder = async (id) => (await apiClient("DELETE", `/knowledge-base/folders/${id}`)).data;
export const deleteKbDocument = async (id) => (await apiClient("DELETE", `/knowledge-base/documents/${id}`)).data;

export async function uploadKbDocument(folderId, file) {
  const form = new FormData();
  form.append("folder_id", folderId);
  form.append("file", file);
  return (await apiClient("POST", "/knowledge-base/documents", form)).data;
}
